const LOCK_KEY = 'refresh_lock';
const LOCK_TIMEOUT = 10000;
const WAIT_INTERVAL = 50;

export function setRefreshLock() {
  localStorage.setItem(LOCK_KEY, String(Date.now()));
}

export function clearRefreshLock() {
  localStorage.removeItem(LOCK_KEY);
}

export function isAnotherTabRefreshing() {
  const ts = parseInt(localStorage.getItem(LOCK_KEY), 10);
  return ts && (Date.now() - ts < LOCK_TIMEOUT);
}

export function waitForRefreshLockToClear(timeout = LOCK_TIMEOUT) {
  return new Promise((resolve) => {
    const startedAt = Date.now();

    const check = () => {
      if (!isAnotherTabRefreshing() || Date.now() - startedAt >= timeout) {
        resolve();
        return;
      }

      setTimeout(check, WAIT_INTERVAL);
    };

    check();
  });
}
